import React, {useEffect, useState} from 'react';
import Carousel from './carousel';
import {Link} from 'react-router-dom';
import {Box, Flex, Image, Text} from '@chakra-ui/react';
import ReactCursorPosition from "react-cursor-position";
import MouseTooltip from 'react-sticky-mouse-tooltip';

const Item = (props) => {
    return (
        <Box>
            <Box
                display={props.tile_type === 'carousel' ? 'grid' : undefined}
                width={'100%'}
                mb={'10px'}
                minH={props.tile_type === 'carousel' ? '187px' : undefined}
            >
                {props.tile_type === 'image' &&
                    (props?.image_url ? (
                        <Box as={props?.link_url?.includes('http') ? 'a' : Link}
                             target={props?.link_url?.includes('http') ? '_blank' : undefined}
                             {...Object.assign(
                                 props?.link_url?.includes('http')
                                     ? {
                                         href: props.link_url,
                                     }
                                     : {
                                         to: {pathname: props?.link_url || '/'},
                                     },
                             )}
                             state={{comingFrom: "home"}}>
                            <ImageWrapped props={props}/>
                        </Box>
                    ) : (
                        <Box
                            display={'flex'}
                            as={'a'}
                            target={'_blank'}
                            href={props?.link_url}
                            alignItems={'center'}
                            justifyContent={'center'}
                            flexDirection={'column'}
                            bgColor={'brand.700'}
                            width={'100%'}
                            height={props?.img_height || 'full'}
                            zIndex={1}
                        >
                            <Text
                                fontWeight={'400'}
                                fontSize={['48px', '64px']}
                                fontFamily={'Springfield'}
                                lineHeight={['48px', '74px']}
                                textAlign={'center'}
                                paddingTop={'6px'}
                                color={'white'}
                                noOfLines={1}
                            >
                                {props.title}
                            </Text>
                            <Text
                                fontWeight={'400'}
                                fontSize={['14px', '16px']}
                                lineHeight={['16px', '26px']}
                                textAlign={'center'}
                                color={'white'}
                                maxW={'500px'}
                                paddingRight={'20px'}
                                paddingLeft={'20px'}
                                dangerouslySetInnerHTML={{
                                    __html: props.subtitle,
                                }}
                            />
                        </Box>
                    ))}

                {props.tile_type === 'carousel' && (
                    <Carousel {...props} data={props.carousel_images}
                              minH={props.minH ? ['187px', '200px'] : undefined}/>
                )}
            </Box>
            <Box as={props?.link_url?.includes('http') ? 'a' : Link}
                 target={props?.link_url?.includes('http') ? '_blank' : undefined}
                 {...Object.assign(
                     props?.link_url?.includes('http')
                         ? {
                             href: props?.link_url,
                         }
                         : {
                             to: {pathname: props?.link_url || '/'},
                         },
                 )}>
                <Text
                    fontWeight={'semibold'}
                    fontSize={'16px'}
                    lineHeight={'32px'}
                    textAlign={'center'}
                    color={'black'}
                    noOfLines={1}
                >
                    {props.size !== 'news' ? props.title : 'Recent News'}
                </Text>
            </Box>
            <Box as={Link}
                 {...Object.assign(
                     {
                         to: props?.subtitle_slug ? `/companies?sector=${props?.subtitle_slug}` : '/companies' || props?.link_url || '/',
                     },
                 )}
                 state={{comingFrom: 'nav'}}>
                <Text
                    textTransform={'uppercase'}
                    fontWeight={'semibold'}
                    fontSize={'8px'}
                    lineHeight={'16px'}
                    textAlign={'center'}
                    color={'blackAlpha.600'}
                >
                    {props.news_category || props.subtitle}
                </Text>
            </Box>
        </Box>
    );
};

export default Item;

const ImageWrapped = ({props}) => {
    const [{x, y}, setMouseCoordinates] = useState({x: 0, y: 0});
    const [isMouseTooltipVisible, setIsMouseTooltipVisible] = useState(false);

    const handleHoverOff = () => {
        if (isMouseTooltipVisible && props?.show_hover) {
            setIsMouseTooltipVisible(false)
        }
    }

    const handleHoverOn = () => {
        if (!isMouseTooltipVisible && props?.show_hover) {
            setIsMouseTooltipVisible(true)
        }
    }

    const toggleHoverState = () => {
        console.log('showHover', props?.show_hover, !isMouseTooltipVisible)
        if(props?.show_hover) {
            setIsMouseTooltipVisible(!isMouseTooltipVisible);
        }
    }
    /*
        
    */

    if (!props?.show_hover) {
        return (
            <Box height={"100%"}>
                <Image
                    width={'100%'}
                    height={props?.img_height}
                    src={props.image_url}
                    key={props.image_url + '_' +Math.random()}
                    alt={`${props.title}-logo`}
                    objectFit={'cover'}
                    minH={props.minH ? '200px' : undefined}
                    fallback={<Box h={props?.img_height || 'full'} w={'full'} bgColor={'brand.600'} bg={'brand.600'}/>}
                />
            </Box>
        )
    }
    return (
        <ReactCursorPosition
            onPositionChanged={({position: {x, y}}) => {
                setMouseCoordinates({x, y});
            }}
        >
            <Box height={"100%"} 
                className={"putHoverHere"}
                onMouseOver={handleHoverOn}
                onMouseLeave={handleHoverOff}
                >
                <Box
                    _hover={{
                        '& #overlay': {
                            opacity: 1,
                            transition: '150ms all ease',
                            paddingBottom: '-14px',
                            // zIndex: 1
                        },
                        '&:before': {
                            content: "''",
                            position: 'absolute',
                            width: '100%',
                            left: 0,
                            height: '1px',
                            backgroundColor: 'white',
                            opacity: 0.2,
                            top: y - 38,
                            zIndex: 51,
                        },
                        '&:after': {
                            content: "''",
                            position: 'absolute',
                            height: '100%',
                            top: 0,
                            width: '1px',
                            backgroundColor: 'white',
                            opacity: 0.2,
                            left: x,
                            zIndex: 51,
                        },
                    }}
                    userSelect={'none'}
                    position={'relative'}
                    top="0"
                    height={'100%'}
                    mb={'14px'}
                    minH={'200px'}
                    overflow={'hidden'}
                    zIndex={50}
                >
                    <MouseTooltip
                        visible={true}
                        offsetX={10}
                        offsetY={5}
                        overflow={'hidden'}
                    >
                        <Text
                            fontSize={'sm'}
                            letterSpacing={'-1px'}
                            lineHeight={'14px'}
                            as={'span'}
                            opacity={isMouseTooltipVisible ? .4 : 0}
                            color={'white'}
                            userSelect={'none'}
                            zIndex={50}
                            display={'block'}
                        >
                            Read more
                        </Text>
                    </MouseTooltip>
                    <Box
                        id={'overlay'}
                        position={'absolute'}
                        inset={0} 
                        px={'20px'}
                        py={'15px'}
                        opacity={0}
                        height={props?.img_height}
                        zIndex={1}
                    >
                        <Flex
                            mb={'2px'}
                            fontSize={'14px'}
                            lineHeight={'3xl'}
                            textTransform={'uppercase'}
                            gap={5}
                        >
                            <Text as={'span'} textColor={'white'}>
                                {props?.company_status}
                            </Text>
                            <Text as={'span'} textColor={'white'}>
                                {props?.investment_status}
                            </Text>
                        </Flex>
                        <Text
                            mb={'2px'}
                            fontSize={'14px'}
                            lineHeight={'3xl'}
                            textAlign={'left'}
                        >
                            <Text as={'span'} textColor={'white'} noOfLines={5}>
                                {props.excerpt}
                            </Text>
                        </Text>
                    </Box>
                    <Image
                        width={'100%'}
                        height={props?.img_height}
                        src={isMouseTooltipVisible ? null : props.image_url}
                        alt={`${props.title}-logo`}
                        objectFit={'cover'}
                        minH={props.minH ? ['187px', '200px'] : undefined}
                        fallback={<Box h={props?.img_height || ['187px', '200px']}  minH={props.minH ? ['187px', '200px'] : undefined}
                                       w={'full'} bgColor={'brand.600'} bg={'brand.600'}/>}
                    />
                </Box>
            </Box>
        </ReactCursorPosition>
    )
}